import { useStore } from 'effector-react'

import {
  $coefficients,
  $totalCount,
  coefficientsListMounted,
  getCoefficients,
  updateCoefficientFx,
  updateCoefficientTriggered,
} from './model'
import { CoefficientListRequest } from './types'

export const useCoefficientsList = () => {
  const coefficients = useStore($coefficients)
  const loading = useStore(getCoefficients.pending)
  const totalCount = useStore($totalCount)
  const updateLoading = useStore(updateCoefficientFx.pending)

  const onChangeCoefficientsList = ({
    limit,
    page,
  }: CoefficientListRequest) => {
    coefficientsListMounted({ limit, page })
  }

  return {
    coefficients,
    totalCount,
    loading,
    onChangeCoefficientsList,
    updateCoefficient: updateCoefficientTriggered,
    updateLoading,
  }
}
